import { setupConstants } from "./setup.constants";

export function setup(state = {}, action) {
    let clientBillingLoading = {};

    switch (action.type) {
        case setupConstants.DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_REQUEST:
            return {
                ...state,
                determineShopifyPaymentProvidersLoading: true,
                determineShopifyPaymentProvidersErrorMessage: null,
                shopifyPaymentProviders: null,
            };

        case setupConstants.DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_SUCCESS:
            return {
                ...state,
                determineShopifyPaymentProvidersLoading: false,
                shopifyPaymentProviders: action.result,
            };

        case setupConstants.DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_FAILURE:
            return {
                ...state,
                determineShopifyPaymentProvidersLoading: false,
                determineShopifyPaymentProvidersErrorMessage: action.errorMessage,
            };

        case setupConstants.GET_SETUP_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };

        case setupConstants.GET_SETUP_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action.result,
            };

        case setupConstants.GET_SETUP_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: action.errorMessage,
            };

        case setupConstants.DELETE_APPSTORE_ACCOUNT_REQUEST:
            return {
                ...state,
                deletionLoading: true,
            };

        case setupConstants.DELETE_APPSTORE_ACCOUNT_SUCCESS:
            return {
                ...state,
                deletionLoading: false,
                status: action.result,
            };

        case setupConstants.DELETE_APPSTORE_ACCOUNT_FAILURE:
            return {
                ...state,
                deletionLoading: false,
            };

        case setupConstants.PREPARE_SHOPIFY_BILLING_FOR_CLIENT_REQUEST:
            clientBillingLoading = state.clientBillingLoading ? state.clientBillingLoading : {};
            clientBillingLoading[action.clientUUID] = true;
            return {
                ...state,
                clientBillingLoading: clientBillingLoading,
                billingErrorMessage: undefined,
                billingLink: undefined,
            };

        case setupConstants.PREPARE_SHOPIFY_BILLING_FOR_CLIENT_SUCCESS:
            clientBillingLoading = state.clientBillingLoading ? state.clientBillingLoading : {};
            clientBillingLoading[action.clientUUID] = false;
            return {
                ...state,
                clientBillingLoading: clientBillingLoading,
                billingStatus: null,
                errorMessage: null,
                billingLink: action.result,
            };

        case setupConstants.PREPARE_SHOPIFY_BILLING_FOR_CLIENT_FAILURE:
            clientBillingLoading = state.clientBillingLoading ? state.clientBillingLoading : {};
            clientBillingLoading[action.clientUUID] = false;

            return {
                ...state,
                clientBillingLoading: clientBillingLoading,
                billingErrorMessage: action.errorMessage,
            };

        case setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_REQUEST:
            clientBillingLoading = state.clientBillingLoading ? state.clientBillingLoading : {};
            clientBillingLoading[action.clientUUID] = true;
            return {
                ...state,
                clientBillingLoading: clientBillingLoading,
                billingErrorMessage: undefined,
                billingLink: undefined,
            };

        case setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_SUCCESS:
            clientBillingLoading = state.clientBillingLoading ? state.clientBillingLoading : {};
            clientBillingLoading[action.clientUUID] = false;
            return {
                ...state,
                clientBillingLoading: clientBillingLoading,
                billingStatus: null,
                errorMessage: null,
                billingLink: undefined,
            };

        case setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_FAILURE:
            clientBillingLoading = state.clientBillingLoading ? state.clientBillingLoading : {};
            clientBillingLoading[action.clientUUID] = false;
            return {
                ...state,
                clientBillingLoading: clientBillingLoading,
                billingErrorMessage: action.errorMessage,
            };

        case setupConstants.ACTIVATE_SHOPIFY_BILLING_REQUEST:
            return {
                ...state,
                billingLoading: true,
                billingErrorMessage: undefined,
                billingStatus: null,
                errorMessage: null,
            };

        case setupConstants.ACTIVATE_SHOPIFY_BILLING_SUCCESS:
            return {
                ...state,
                billingLoading: false,
                billingLink: action.result,
            };

        case setupConstants.ACTIVATE_SHOPIFY_BILLING_FAILURE:
            return {
                ...state,
                billingLoading: false,
                billingErrorMessage: action.errorMessage,
            };

        default:
            return state;
    }
}
